import load_script from "../util/load_script";

/**
 *
 * @param config GMR kit config
 */
export default function(config) {
  const mygames_scripts_url = "//store.my.games/hotbox/gem_static/leela/header.js?r=";
  window.__GEMS = config;

  load_script(mygames_scripts_url + Math.random());
}
